import { useState, useEffect } from 'react'

// create and export your custom hooks here

// custom hook to check if the window is mobile after resize
export const useWindowResize = () => {
    const [isMobileNow, setIsMobileNow] = useState(window.innerWidth < 768)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsMobileNow(true)
            } else {
                setIsMobileNow(false)
            }
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return isMobileNow
}
